import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "primevue/resources/themes/fluent-light/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.min.css";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";

import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import MenuBar from "primevue/menubar";
import Panel from "primevue/panel";
import BlockUI from "primevue/blockui";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Row from "primevue/row";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import SelectButton from "primevue/selectbutton";
import Password from "primevue/password";
import Dialog from "primevue/dialog";
import InputNumber from "primevue/inputnumber";
import Checkbox from "primevue/checkbox";
import InputSwitch from "primevue/inputswitch";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dropdown from "primevue/dropdown";
import Toast from "primevue/toast";
import Sidebar from "primevue/sidebar";
import Card from "primevue/card";
import InputMask from "primevue/inputmask";
import AutoComplete from "primevue/autocomplete";
import MegaMenu from "primevue/megamenu";
import Calendar from "primevue/calendar";
import RadioButton from "primevue/radiobutton";
import Textarea from "primevue/textarea";
import Listbox from "primevue/listbox";
import FileUpload from "primevue/fileupload";
import Message from "primevue/message";
import Galleria from "primevue/galleria";
import Tooltip from "primevue/tooltip";
import MultiSelect from "primevue/multiselect";
import Avatar from "primevue/avatar";
import Chart from "primevue/chart";
import Timeline from "primevue/timeline";
import Knob from "primevue/knob";
import Badge from "primevue/badge";
import PrimeVue from "primevue/config";

const app = createApp(App);

app.use(PrimeVue, { ripple: true });
app.use(ToastService);
app.use(ConfirmationService);

app.directive("tooltip", Tooltip);

app.component("AutoComplete", AutoComplete);
app.component("Avatar", Avatar);
app.component("BlockUI", BlockUI);
app.component("MenuBar", MenuBar);
app.component("MegaMenu", MegaMenu);
app.component("Calendar", Calendar);
app.component("Checkbox", Checkbox);
app.component("Panel", Panel);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("DataTable", DataTable);
app.component("Row", Row);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Button", Button);
app.component("Password", Password);
app.component("Dialog", Dialog);
app.component("InputSwitch", InputSwitch);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Dropdown", Dropdown);
app.component("Toast", Toast);
app.component("Sidebar", Sidebar);
app.component("Card", Card);
app.component("InputMask", InputMask);
app.component("RadioButton", RadioButton);
app.component("Textarea", Textarea);
app.component("Listbox", Listbox);
app.component("FileUpload", FileUpload);
app.component("Message", Message);
app.component("Galleria", Galleria);
app.component("MultiSelect", MultiSelect);
app.component("Chart", Chart);
app.component("Timeline", Timeline);
app.component("Knob", Knob);
app.component("Badge", Badge);
app.component("SelectButton", SelectButton);

app
  .use(store)
  .use(router)
  .mount("#app");
